export const SAVE_DKW = 'save_dkw';
export const SAVE_DKW_MESH_ID = 'save_dkw_mesh_id';
export const LOAD_TOP_HOSPITALS = 'load_top_hospitals';
